module.exports = __webpack_public_path__ + "d266968c.png";